import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { InviteEndorserForm } from "./InviteEndorserForm";
import { useInvitations } from "../hooks/useInvitations";
import { RoleType, ENDORSEMENT_VALIDATION } from "@promo/shared";
import { Badge } from "@/components/ui/badge";

interface InviteEndorserDialogProps {
  packetId: string;
  defaultOpen?: boolean;
}

export function InviteEndorserDialog({ packetId, defaultOpen = false }: InviteEndorserDialogProps) {
  const [open, setOpen] = useState(defaultOpen);
  const { data: existingInvitations = [] } = useInvitations(packetId, RoleType.ENDORSER);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>Invite Endorser</Button>
      </DialogTrigger>
      <DialogContent forceMount className="sm:max-w-[425px] bg-background border border-input shadow-lg">
        <DialogHeader>
          <DialogTitle className="flex flex-row items-center justify-between pr-6">
            <div>Invite endorsers</div>
            <Badge variant="secondary">
              {existingInvitations.length} of {ENDORSEMENT_VALIDATION.MAX_ENDORSERS}
            </Badge>
          </DialogTitle>
        </DialogHeader>
        <InviteEndorserForm
          packetId={packetId}
          onSuccess={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
} 